<template>
  <div class="content">
    <div class="topMess">
      <div class="messDetail">
        <HeadTop/>
        <span style="margin-left:10px;font-size: 18px">></span>
        <span style="margin-left:10px;">{{ title }}</span>
      </div>
    </div>
    <div class="video">
      <div class="videoDetail">
        <video controls autoplay width="800px" height="500px;" :src="resBaseVideo+'/'+videoUrl"></video>
      </div>
      <div class="detailMess">
        <div class="title">{{ videoMess.title }}</div>
        <a-row class="detail">
          <a-col class="detailLeft" :span="2">内容简介</a-col>
          <a-col class="detailRight" :span="17">{{ videoMess.content || '暂无信息' }}</a-col>
        </a-row>
        <a-row class="detail">
          <a-col class="detailLeft" :span="2">主讲人</a-col>
          <a-col class="detailRight" :span="17">
            {{ videoMess.author }}
            <div>{{ videoMess.authorInfo || '暂无信息' }}</div>
          </a-col>
        </a-row>
        <!-- <a-row class="detail">
            <a-col class="detailLeft" :span="2">类型</a-col>
            <a-col class="detailRight" :span="17">{{videoMess.liveTeacherInfo || '暂无信息'}} {{videoMess.liveTeacherName}}</a-col>
        </a-row> -->
        <!-- <a-button @click="fullScreen">测试</a-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import HeadTop from '@/components/HeadTop.vue'
import format from '@/utils/format.js'
import requestUrl from '../../utils/requestUrl'
// import screenfull from 'screenfull'
export default {
  name: 'snailVideoDetail',
  data () {
    return {
      format,
      resBaseVideo: this.$resBaseVideo,
      indexNum: 1, // 默认为1,
      totalNum: 0,
      videoMess: '',
      videoUrl: '',
      title: '',
      showPlayImg: false
    }
  },
  watch: {
    $route () {
      // console.log(this.$route)
    }
  },
  mounted () {
    this.getMess()
  },
  methods: {
    getMess () {
      this.videoMess = JSON.parse(sessionStorage.getItem('videoDetail'))
      // this.videoMess = this.$route.params.item
      this.title = this.videoMess.title
      this.videoUrl = this.videoMess.fileList[0].path
      this.watch(this.videoMess)
    },
    watchVideo (i, index) {
      this.showPlayImg = true
      this.indexNum = index + 1
      this.$refs.iframe.contentWindow.location.replace(i.playUrl)
    },
    fullScreen () {
      const element = document.getElementById('full_screen')
      screenfull.request(element)
      // console.log(this.$refs.iframe.contentWindow)
    },
    watch (item) {
      const param = {
        access_token: localStorage.getItem('access_token'),
        id: item.id
      }
      this.$http.post(requestUrl.saveMediaPlayCount, param).then(res => {
        if (res) {
        }
      })
    }
  },
  components: {
    HeadTop
  }
}
</script>

<style lang="less" scoped>
ul, li {
  margin: 0;
  padding: 0;
  list-style: none;
}

.content {
  background: #fff;
  height: 100%;
  width: 100%;
  min-width: 1240px;
  border-radius: 8px;

  .topMess {
    display: flex;
    background: #fff;
    //height: 60px;
    line-height: 20px;
    width: 100%;
    border-radius: 8px;

    .messDetail {
      margin: 0 30px;
      height: 60px;
      min-width: 1240px;
      line-height: 60px;
      display: flex;
      text-align: center;
    }
  }

  .video {
    // height:650px;
    display: flex;
    width: 100%;
    min-width: 1240px;
    margin: 0 auto;
    padding: 0px 0px 50px 0px;

    .videoDetail {
      width: 60%;
      height: 500px;
      margin: auto 0 auto auto;
      text-align: center;
    }

    .detailMess {
      width: 40%;
      height: 100%;
      margin: auto auto auto 0;
      text-align: left;
      padding: 0px 0px 30px 30px;

      .title {
        font-weight: bold;
        color: #000000;
        line-height: 30px;
        font-size: 20px;
      }

      .detail {
        margin-top: 10px;

        .detailLeft {
          width: 80px;
          height: 26px;
          line-height: 26px;
          background: #fbeeec;
          border-radius: 13px;
          color: #DB5647;
          font-size: 16px;
          text-align: center;
        }

        .detailRight {
          padding-left: 10px;
          color: #000;
          font-size: 16px;
          line-height: 22px;
        }
      }

      .videoList {
        border: 1px solid #ccc;
        color: #000;
        font-size: 12px;
        margin-top: 20px;
        cursor: pointer;

        .listLi1, .listLi {
          width: 100%;
          line-height: 30px;
          padding: 0px 10px;
        }

        .listLi1 {
          background: #FFF;
        }

        .listLi {
          background: #F6F6F6;
          border-top: 1px solid #ccc;

          .name {
            display: inline-block;
            word-wrap: break-all;
          }
        }

        .playImg {
          width: 12px;
          height: 12px;
          margin-top: -5px;
          margin-right: 3px;
        }
      }
    }
  }
}

.activeLi {
  color: #DB5647;
  width: 100%;
  line-height: 30px;
  padding: 0px 10px;
  border-top: 1px solid #ccc
}
</style>
